import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement("g", { clipPath: "url(#clip0_1461_24955)" }, /* @__PURE__ */ e.createElement("g", { fill: "#333" }, /* @__PURE__ */ e.createElement("path", { d: "M15.113 11.293a.813.813 0 00-.813.807v1.233a1.047 1.047 0 01-1.047 1.047H2.747A1.047 1.047 0 011.7 13.333V12.1a.813.813 0 00-1.62 0v1.233A2.667 2.667 0 002.747 16h10.506a2.667 2.667 0 002.667-2.667V12.1a.807.807 0 00-.807-.807z" }), /* @__PURE__ */ e.createElement("path", { d: "M8 0a1.293 1.293 0 00-1.293 1.293v6.04a.167.167 0 01-.167.167H4.767a.667.667 0 00-.487 1.067l3.233 3.72a.667.667 0 00.974 0l3.233-3.72a.665.665 0 00-.487-1.067H9.46a.167.167 0 01-.167-.167v-6.04A1.293 1.293 0 008 0z" }))),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "clip0_1461_24955" }, /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0H16V16H0z" })))
);
export {
  a as default
};
